import { FC } from "react";
import { useSelector } from "react-redux";

import { SettingsToolIcon } from "shared/ui";
import type { IndicatorName } from "../../model";
import { selectIndicatorsInstances } from "../../model";
import { INDICATORS } from "../config";
import { getInputSummary } from "./getInputSummary";

import styles from "../select-indicators/SelectIndicators.module.css";

interface Props {
  onIndicatorClick: (id: string, name: IndicatorName, label: string) => void;
}

export const CurrentIndicatorsList: FC<Props> = ({ onIndicatorClick }) => {
  const instances = useSelector(selectIndicatorsInstances);

  if (instances.length === 0) {
    return <p className={styles.empty}>No indicators selected</p>;
  }

  const indicatorOrder = Object.fromEntries(
    INDICATORS.map((ind, i) => [ind.name, i]),
  );
  const sorted = [...instances].sort(
    (a, b) => (indicatorOrder[a.name] ?? 0) - (indicatorOrder[b.name] ?? 0),
  );

  return (
    <ul className={styles.list}>
      {sorted.map((instance) => {
        const config = INDICATORS.find((ind) => ind.name === instance.name);
        if (!config) return null;
        const summary = getInputSummary(instance.name, instance.settings);
        return (
          <li
            key={instance.id}
            className={styles.item}
            onClick={() => onIndicatorClick(instance.id, instance.name, config.label)}
          >
            <span className={styles.itemLabel}>
              {config.label}
              {summary && <span className={styles.itemParams}> {summary}</span>}
            </span>
            <SettingsToolIcon className={styles.settingsIcon} />
          </li>
        );
      })}
    </ul>
  );
};
